import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, ref } from 'vue';
import apis from "@/api";
import SensitiveWords from "../components/SensitiveWords";
export default {
  __name: 'UpLoad',
  props: {
    title: {
      type: String,
      default: '文件上传',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    demand: {
      type: Object,
      default: () => {
        return {
          demandId: 'finishedAssets',
          demandName: '成品物料'
        };
      },
      required: false
    }
  },
  emits: ['uploadSuccess', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const data = reactive({
      sensWordsList: [],
      assetsIds: '',
      fileList: []
    });
    const fileLoading = ref(false);
    const submitUpload = () => {
      if (!data.fileList || data.fileList.length == 0) {
        ElMessage.error('请先选取文件');
        return;
      }
      fileLoading.value = true;
      let formData = new FormData();
      data.fileList.forEach(f => {
        formData.append('fileList', f);
      });
      formData.append('demandId', 'finishedAssets');
      formData.append('demandName', '成品物料');
      formData.append('bucketName', 'outer-for-inner');
      apis.upload(formData).then(res => {
        console.log("upload-res: ", res);
        if (res && res.success) {
          const sensList = [];
          res.data.forEach(file => {
            let sens = {};
            sens.assetsId = file.id;
            sens.assetsContent = file.relativeUrl;
            sens.assetsName = file.fileName;
            for (let sw of data.sensWordsList) {
              if (sw.assetsName == file.fileName) {
                sens.sensitiveWords = sw.sensitiveWords;
              }
            }
            sensList.push(sens);
          });
          apis.saveAsws(sensList);
          emits('uploadSuccess', res.data);
          ElMessage.success('文件上传成功');
        } else {
          ElMessage.error('文件上传失败:' + res.msg);
        }
        fileLoading.value = false;
      }).catch(err => {
        console.log("err", err);
        ElMessage.error('文件上传失败');
        fileLoading.value = false;
      });
    };
    const checkSensitive = file => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        apis.checkSwByBase64({
          imgBase64: e.target.result
        }).then(res => {
          if (res.code == 200 && res.data) {
            data.sensWordsList.push({
              assetsName: file.name,
              sensitiveWords: res.data
            });
          }
        });
      };
    };
    const uploadFiles = params => {
      checkSensitive(params.file);
      data.fileList.push(params.file);
    };
    const beforeUpload = rawFile => {
      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif') {
        ElMessage.error('文件类型不支持:' + rawFile.type);
        return false;
      }
      if (rawFile.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小超出限制');
        return false;
      }
      return true;
    };
    const close = () => {
      data.fileList = [];
      data.sensWordsList = [];
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        width: "30%",
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          "http-request": uploadFiles,
          "file-list": data.fileList,
          "before-upload": beforeUpload
        }, {
          trigger: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("选取文件", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "btn-right",
            type: "success",
            onClick: submitUpload,
            loading: fileLoading.value
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("上传", -1)]))]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        }, 8, ["file-list"]), _createVNode(_unref(SensitiveWords), {
          "sens-words-list": data.sensWordsList
        }, null, 8, ["sens-words-list"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};